import { Component } from 'react';
import { connect } from 'react-redux';
import firebase from 'firebase/app';

import { withRouter } from 'react-router-dom';

import { appDone, appWait } from '../../store/actions/app.js';

import { sensorsConnect, 
         sensorsDisconnect, 
         sensorsUpdate } from '../../store/actions/sensors.js';

class ServSensors extends Component{
    constructor(props){
        super(props);

//*** Instance Variables
        this.sensorsDisconnect = [];
        // this.fbapp = window.fbapp;
    }
    
    componentDidUpdate(){
        this._handleUpdates();
    }
    
    render(){
      return null;
    }

    //********************************
    _handleUpdates(){
        switch (this.props.sensorsState) {
            case 1:
                this._sensorsConnect();
                break;

            case 4:
                this._sensorsDisconnect();
                break;

            default:
                break;
        }
    }

    _processSensorsQsnap(qSnap){
        let snapSensor = {};
        
        try {
            snapSensor = qSnap.docs[0].data();            
        } catch (err) {
            return;
        }

        let sensors = this.props.sensors;

        let found = false;
        sensors.forEach((i,idx)=>{
            if (i.uin === snapSensor.uin){
                sensors[idx] = snapSensor;
                found = true;
            }
        });

        if (!found){
            sensors.push(snapSensor);
        }

        this.props.sensorsUpdate(sensors);
        this.props.appDone();
    }

    _sensorsConnect(){
        this.sensorsDisconnect.forEach(f=>f());

        let that = this;
        this.props.appWait();

        that.props.deliveries.forEach(i=>{
            let uin = parseInt(i.sensor_uin,10);            

            let disconnect = firebase.firestore().collection("sensors")            
                .where("uin", "==", uin)
                .onSnapshot(qSnap=>this._processSensorsQsnap(qSnap));

            this.sensorsDisconnect.push(disconnect);
        },err=>{
            console.log(err);
            this._sensorsDisconnect();
        });        
    }

    _sensorsDisconnect(){
        this.sensorsDisconnect.forEach(f=>f());
        this.sensorsDisconnect = [];
        
        this.props.appDone();
    }
}

const mapStateToProps = state => {
    return {
        deliveries: state.deliveries.deliveries,

        sensors: state.sensors.sensors,
        sensorsState: state.sensors.sensorsState
    }
}

const mapDispatchToProps = dispatch => {
    return {
        appDone: () => dispatch(appDone()),
        appWait: () => dispatch(appWait()),

        sensorsUpdate: data => dispatch(sensorsUpdate(data)),
        sensorsConnect: data => dispatch(sensorsConnect(data)),
        sensorsDisconnect: data => dispatch(sensorsDisconnect(data))
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(ServSensors));


// WEBPACK FOOTER //
// ./src/containers/Cservices/ServSensors.js